import { Redirect } from "expo-router";

/** Storybook is only published for the web app. */
export default function StorybookScreen() {
  return <Redirect href="/not-found" />;
}
